import { useState } from "react";
import axios from 'axios';
import blogData from "../backend/blogdata.json";

const AddNewBlog = () => {
    const [title, setTitle] = useState('');
    const [date, setDate] = useState('');
    const [tags, setTags] = useState('');
    const [imgpath,setImgpath] = useState('')
    const [apiimgpath,setAPIImgpath] = useState('')
    const [blogContent, setBlogContent] = useState('');
    const [isAdded,setIsAdded] = useState('')

    const publishBlog = async(e) => {
        e.preventDefault();
        
        const newBlog = {
            id: (Object.keys(blogData).length) + 1,
            title: title,
            url: title.replace(/\s/g, '-'),
            date: date,
            tags: ["all",tags],
            content: `./markdown/${title}.md`,
            blogContent: blogContent,
            imgpath: `./blog images/${imgpath}`,
        };
        
        const formData = new FormData();
        formData.append('image', apiimgpath);

        const response = await axios.post('http://localhost:3000/addBlog', newBlog);
        setIsAdded(response.data.message)

        const imgresponse = await axios.post('http://localhost:3000/addImage', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    
    const clearFields = () => {
        window.location.reload();
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        // console.log(file.name);
        setImgpath(file.name);
        setAPIImgpath(file);
      };

    return (
        <div className="mt-20">
            <div className="flex flex-col w-[300px]">
                <input placeholder="title" className="border-2 border-black" onChange={(e) => setTitle(e.target.value)}/>
                <input placeholder="date" className="border-2 border-black mt-2" onChange={(e) => setDate(e.target.value)}/>
                <input placeholder="tags" className="border-2 border-black my-2" onChange={(e) => setTags(e.target.value)}/>
                <input type="file" onChange={handleFileChange}/>
                <textarea placeholder="blog content in md" className="border-2 border-black" onChange={(e) => setBlogContent(e.target.value)}/>
                <button className="bg-black text-white mt-2" onClick={publishBlog}>Publish</button>
                <button onClick={clearFields} className="bg-red-600 text-white mt-2">Clear</button>
                {isAdded ? <p className="text-green-700">{isAdded}</p> : null}
            </div>
        </div>
    );
};

export default AddNewBlog;